import { createContext, useContext, useMemo, useState } from 'react';

interface ServiceSidebarContextProps {
  children: React.ReactNode;
}

const ServiceSidebarContext = createContext<{
  isServiceCollapsed: boolean;
  setIsServiceCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
} | null>(null);

const ServiceSidebarProvider = ({ children }: ServiceSidebarContextProps) => {
  const [isServiceCollapsed, setIsServiceCollapsed] = useState(false);

  const value = useMemo(
    () => ({
      isServiceCollapsed,
      setIsServiceCollapsed,
    }),
    [isServiceCollapsed]
  );

  return (
    <ServiceSidebarContext.Provider value={value}>
      {children}
    </ServiceSidebarContext.Provider>
  );
};

const useServiceSidebar = () => {
  const context = useContext(ServiceSidebarContext);
  if (!context) {
    throw new Error(
      'useServiceSidebar must be used within ServiceSidebarProvider'
    );
  }
  return context;
};

export { ServiceSidebarProvider, useServiceSidebar };
